import React from 'react';
import PropTypes from 'prop-types';

import { camelize } from 'inflected';
import displayName from 'component-lib/displayName';

import AppSwitcherTab from './AppSwitcherTab';
import appSwitcherTabPropTypes from './utils/appSwitcherTabPropTypes';

import { APP_SWITCHER } from './config';

import styles from './AppHeader.scss';

const { TABS } = APP_SWITCHER;

function AppSwitcher(props) {
    const { active, isStaticActiveApp, hasEndUserRole, isOnlyEndUser } = props;

    const onClickForKey = key => props[`on${camelize(key)}Click`];

    let archivingTabs;

    switch (true) {
    case isOnlyEndUser:
        archivingTabs = ['personal_archiving'];
        break;

    case !hasEndUserRole:
        archivingTabs = ['archiving'];
        break;

    default:
        archivingTabs = TABS.filter(key => onClickForKey(key));
    }

    const visibleTabs = isStaticActiveApp ? [active] : archivingTabs;

    function tabProps(key) {
        return {
            id: key,
            key,
            ...(isStaticActiveApp && {
                status: 'static',
            }),
            ...(!isStaticActiveApp && {
                onClick: onClickForKey(key),
                status: key === active ? 'active' : 'inactive',
            }),
        };
    }

    return (
        <div className={styles['global-header-tabs']}>
            {visibleTabs.map(key => (
                <AppSwitcherTab {...tabProps(key)} />
            ))}
        </div>
    );
}

AppSwitcher.displayName = displayName('AppHeader/AppSwitcher');

AppSwitcher.propTypes = {
    ...appSwitcherTabPropTypes,
    active: PropTypes.oneOf(TABS).isRequired,
    isStaticActiveApp: PropTypes.bool.isRequired,
    hasEndUserRole: PropTypes.bool,
    isOnlyEndUser: PropTypes.bool,
};

AppSwitcher.defaultProps = {
    hasEndUserRole: false,
    isOnlyEndUser: false,
};

export default AppSwitcher;
